import api from 'services/api'

interface ParamsAdminUser {
  companyId: string
  params: { email: string }
}

enum AdminStatusType {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
const addAdminUser = async ({ companyId, params }: ParamsAdminUser): Promise<void> => {
  return api.post(`/v2/company/${companyId}/admin-management/`, {
    email: params.email,
    status: AdminStatusType.ACTIVE,
  })
}

const revokeAdminAccess = async ({ companyId, params }: ParamsAdminUser): Promise<void> => {
  return api.put(`/v2/company/${companyId}/admin-management/`, {
    email: params.email,
    status: AdminStatusType.INACTIVE,
  })
}

export default {
  addAdminUser,
  revokeAdminAccess,
}
